import React, { useState, useEffect } from 'react'
import { InputLabel, Select, FormControl, FilledInput, Icon } from '@material-ui/core'
import { Field } from 'react-final-form'
import { makeStyles } from '@material-ui/styles'
import FormHelperText from '@material-ui/core/FormHelperText'
import { Translation } from 'react-i18next'

// STYLES
const useStyles = makeStyles(theme => ({
	formControl: {
		width: '100%',
		display: 'block',
	},
	labelRoot: {
		color: theme.palette.secondary.main,
	},
	labelFocused: {
		color: theme.palette.secondary.main + ' !important',
	},
	inputRoot: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.secondary.main,
		width: '100%',
		border: 'solid 0.5px',
		borderColor: theme.palette.secondary.main,
		borderRadius: '5px',
		'&:before': {
			display: 'none',
		},
		'&:after': {
			display: 'none',
		},
	},
	filledInputRoot: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.secondary.main,
		width: '100%',
		'&:before': {
			display: 'none',
		},
		'&:after': {
			display: 'none',
		},
	},
	inputFocused: {
		'&:after': {
			borderColor: theme.palette.primary.main,
		},
	},
	arrowColor: {
		color: theme.palette.secondary.main,
		marginRight: '10px',
	},
	menuRoot: {
		backgroundColor: 'white',
		color: 'white !important',
	},
	inputSize: {
		padding: '22px 12px 10px',
	},
	textColor: {
		color: theme.palette.primary.main,
		backgroundColor: '#3268A7 !important',
		'&:hover': {
			color: '#3268A7',
			backgroundColor: theme.palette.primary.main + '!important',
		},
	},
	helperText: {
		minHeight: '0px',
		color: '#E10032',
		margin: '8px 12px 0',
	},
}))

export default function InputSelectField({
	onChange,
	validate,
	name,
	label,
	children,
	initialSelected,
	...props
}) {
	const classes = useStyles()
	const [value, setValue] = useState([])

	const myOnChange = event => {
		setValue([...event.target.value])
	}

	useEffect(() => {
		if (initialSelected) setValue(initialSelected)
	}, [initialSelected])

	return (
		<Field
			name={name}
			validate={validate}
			render={({ input, meta }) => {
				const mergedOnChange = e => {
					myOnChange(e)
					input.onChange(e)
					if (onChange) onChange(e)
				}
				const newInput = { ...input, onChange: mergedOnChange }
				return (
					<FormControl variant="filled" className={classes.formControl} {...props}>
						<InputLabel
							htmlFor="select-multiple"
							classes={{
								root: classes.labelRoot,
								focused: classes.labelFocused,
							}}
						>
							{label}
						</InputLabel>
						<Select
							multiple={true}
							value={value}
							MenuProps={{
								classes: {
									paper: classes.menuRoot,
								},
							}}
							IconComponent={props => (
								<Icon
									{...props}
									classes={{
										root: classes.arrowColor,
									}}
								>
                  arrow_drop_down
								</Icon>
							)}
							inputProps={{
								className: classes.inputSize,
							}}
							input={
								<FilledInput
									classes={{
										root: classes.inputRoot,
										focused: classes.inputFocused,
									}}
									{...newInput}
								/>
							}
						>
							{children}
						</Select>
						<FormHelperText classes={{ root: classes.helperText }}>
							{meta && meta.touched && meta.error ? (
								<Translation ns="validateData">{t => <>{t(meta.error)}</>}</Translation>
							) : (
								undefined
							)}
						</FormHelperText>
					</FormControl>
				)
			}}
		/>
	)
}
